import invariant from 'tiny-invariant';

import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useAppContext } from 'business/contextProviders/useAppContext';
import { useRecordSegmentDefectV1ControllerGetRangeStats } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useGetRangeStats = (
  startRing: number | null,
  endRing: number | null,
  isRangeValid: boolean,
) => {
  const restHeaders = useRestApiHeaders(Module_Enum.QualityControl);
  const { currentConstructionSiteId } = useAppContext();
  invariant(currentConstructionSiteId, 'No construction site selected');

  return useRecordSegmentDefectV1ControllerGetRangeStats(
    {
      pathParams: {
        constructionSiteId: currentConstructionSiteId,
      },
      queryParams: {
        startRing: startRing ?? -1,
        endRing: endRing ?? -1,
      },
      headers: restHeaders,
    },
    { enabled: isRangeValid },
  );
};
